<template>
  <div class="terms-of-service">
    <div class="service-content">
<!--      <div class="sr-icon">-->
<!--        <img src="@/static/eMoneyLogo-tron_3.svg" width="80" height="80" alt="" class="cs-img-icon">-->
<!--      </div>-->
<!--      <h3 class="sr-title" style="width: 50%; margin-top: 40px">-->
<!--        <van-progress :percentage="percent" :show-pivot="false" color="#00bcd4" track-color="#C4C4C4" :stroke-width="8"/>-->
<!--      </h3>-->
<!--      <p class="sr-subTitle">  {{ $t("downloading")}} </p>-->
      <VueSpinner size="50" :color="color_primary()" />
    </div>
  </div>

</template>

<script src="./index.js" ></script>

<style src="./index.css" lang="css" scoped> </style>
